// extracted by mini-css-extract-plugin
export default {"ComboSelector":"XjUXAnCLxrJU_S3Faibn","Label":"bbDHU4_JdA0hl9MD1Lrq","Variant--dark":"lGjVadSc7bzjE2LzD3Ec","Variant--light":"km5O6Vr04dX9qXqlrGMV"};